// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"Contracts_paginationPageDropdownWrap__CPIKM","linkCellStyle":"Contracts_linkCellStyle__6ALX+","pageLink":"Contracts_pageLink__X--RC"};